import React from "react";

function About() {
  return (
    <div className={"about-container"}>
      <div className={"about"}>
        <h2>about</h2>
        <p>
          このサイトは作者がギターの練習用に制作したサイトです。
          音楽・ギター初心者が作成したため誤りがある可能性があります。
        </p>
        <p>
          間違いの指摘やアドバイス、リクエストなどがあれば
          <a href="https://twitter.com/yoigara3">@yoigara3</a>
          までよろしくお願いします。
        </p>
      </div>
    </div>
  );
}

export default About;
